var render, staticRenderFns
import script from "./customSubFormItem.vue?vue&type=script&lang=js"
export * from "./customSubFormItem.vue?vue&type=script&lang=js"
import style0 from "./customSubFormItem.scss?vue&type=style&index=0&id=dad9607a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dad9607a",
  null
  
)

export default component.exports